import * as actions from './HealthFiltersActionsType';

const FILTER_KEY = 'dvrHealthFilters';

const saveFilter = filter => {
  localStorage.setItem(FILTER_KEY, JSON.stringify(filter));
};

const clearFilter = () => {
  localStorage.removeItem(FILTER_KEY);
}

const getInitialFilter = () => {
  const filter = localStorage.getItem(FILTER_KEY);
  if (filter) {
    return JSON.parse(filter);
  }
  return {
    chips: [],
    groups: [],
    status: 'all',
    cardView: 'standard'
  };
}

export const initialState = () => ({
  applied: getInitialFilter(),
  groups: {
    loading: false,
    entries: []
  },
  status: {
    loading: false,
    entries: []
  },
  chipsOptions: {
    loading: false,
    entries: []
  }
});

export default (state = initialState(), action = {}) => {
  const {type} = action;
  switch (type) {
    case actions.SEARCH_REQUEST:
      return {...state, chipsOptions: {...state.chipsOptions, loading: true}};
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        chipsOptions: {...state.chipsOptions, loading: false, entries: action.payload}
      };
    case actions.SEARCH_FAILURE:
      return {...state, chipsOptions: {...state.chipsOptions, loading: false}};
    case actions.SEARCH_CLEAR:
      return {...state, chipsOptions: initialState().chipsOptions};
    case actions.GROUPS_REQUEST:
      return {...state, groups: {...state.groups, loading: true}};
    case actions.GROUPS_SUCCESS:
      return {...state, groups: {...state.groups, loading: false, entries: action.payload}};
    case actions.GROUPS_FAILURE:
      return {...state, groups: {...state.groups, loading: false}};
    case actions.STATUS_REQUEST:
      return {...state, status: {...state.status, loading: true}};
    case actions.STATUS_SUCCESS:
      return {...state, status: {...state.status, loading: false, entries: action.payload}};
    case actions.STATUS_FAILURE:
      return {...state, status: {...state.status, loading: false}};
    case actions.SET_CHIP:
      saveFilter({...state.applied, chips: action.payload});
      return {...state, applied: {...state.applied, chips: action.payload}};
    case actions.SET_GROUPS:
      saveFilter({...state.applied, groups: action.payload});
      return {...state, applied: {...state.applied, groups: action.payload}};
    case actions.SET_STATUS:
      saveFilter({...state.applied, status: action.payload});
      return {...state, applied: {...state.applied, status: action.payload}};
    case actions.SET_CARDVIEW:
      saveFilter({...state.applied, cardView: action.payload});
      return {...state, applied: {...state.applied, cardView: action.payload}};
    case actions.CLEAR_HIDEABLE:
      clearFilter();
      return {
        ...state,
        applied: {
          ...state.applied,
          groups: initialState().applied.groups,
          status: initialState().applied.status,
          cardView: initialState().applied.cardView,
          chips: initialState().applied.chips
        }
      };
    case actions.CLEAR_FILTER_MOBILE:
      clearFilter();
      return {
        ...state,
        applied: {
          ...state.applied,
          chips: initialState().applied.chips,
          groups: initialState().applied.groups,
          status: initialState().applied.status,
          cardView: initialState().applied.cardView
        }
      };
    case actions.CLEAR:
      clearFilter();
      return {...state, ...initialState()};
    default:
      return state;
  }
};
